import _ from 'lodash';

import {
  CONTACT_SOURCE_LABELS,
  ContactGroup,
  SOURCE_KIND_GROUPS,
  SYSTEM_KEY_PREFIX_GROUPS,
} from 'constants/contactSources';

/**
 * @param {string|null} sourceKind
 * @returns {string|null} the Source chip text; null for a contact created in CRM
 */
export const getContactSourceLabel = sourceKind =>
  _.isNil(sourceKind) ? null : (CONTACT_SOURCE_LABELS[sourceKind] ?? sourceKind);

/**
 * @param {{ sourceKind?: string|null, systemKey?: string|null }} contact
 * @returns {string} a ContactGroup value
 */
export const getContactGroup = ({ sourceKind = null, systemKey = null }) => {
  const systemKeyGroup = systemKey
    ? SYSTEM_KEY_PREFIX_GROUPS.find(({ prefix }) => systemKey.startsWith(prefix))?.group
    : null;

  return systemKeyGroup ?? SOURCE_KIND_GROUPS[sourceKind] ?? ContactGroup.OTHER;
};

/**
 * @param {string} group a ContactGroup value
 * @returns {string[]} the source kinds whose contacts the group holds
 */
export const getGroupSourceKinds = group =>
  Object.keys(SOURCE_KIND_GROUPS).filter(sourceKind => SOURCE_KIND_GROUPS[sourceKind] === group);
